export default "__VITE_ASSET__ff6797f5__"